import React, { useState, useEffect, useRef } from "react";
import { HTTP } from "../../api/http-common";
import { useNavigate } from "react-router-dom";
import { isValidEmail } from '../../component/common';
// import { Eye, EyeOff } from "lucide-react";
import Swal from 'sweetalert2'
import { X } from "lucide-react";
import ImageCropper from "./ImageCropper";
// import { useGlobalContext } from "./../../component/GlobalContext";
function VendorProfile() {
  const [imageSrc, setImageSrc] = useState(null); // Store selected image source
  const [bannerImageSrc, setBannerImageSrc] = useState('');
  const navigate = useNavigate();
  const [isImageChanged, setIsImageChanged] = useState(false);
  const [isBannerImageChanged, setIsBannerImageChanged] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [businessNameError, setBusinessNameError] = useState("");
  const [businessDescriptionError, setBusinessDescriptionError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [shortDescriptionError, setShortDescriptionError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [urlError, setUrlError] = useState("");
  const [categoryIdError, setCategoryIdError] = useState("");

  const [facebookError, setFacebookError] = useState("");
  const [xError, setXError] = useState("");
  const [youtubeError, setYoutubeError] = useState("");
  const [pagination, setPagination] = useState({ page: '1', limit: '100' });

  // const [bannerImage, setBannerImage] = useState(null); // State for the banner image
  const [fileError, setFileError] = useState("");
  const [bannerPreview, setBannerPreview] = useState(null); // To store image preview URL

  const [mainBannerPreview, setMainBannerPreview] = useState(null);
  const [formData, setFormData] = useState({
    business_name: "",
    business_category_id: "",
    business_description: "",
    email: "",
    phone_number: "",
    owner_first_name: "",
    owner_last_name: "",
    business_site_url: "",

    facebook_url: "",
    x_url: "",
    youtube_url: "",
    banner_image: "",
    short_description: "",
    main_banner_image: ""

  });

  const fileInputRef = useRef(null);
  const fileInputRef2 = useRef(null);

  useEffect(() => {
    setPagination({ page: '1', limit: '100' })
    loadCategories();
    loadvendor();
  }, []);

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        setImageSrc(reader.result); // Set the image source from the uploaded file
        setIsImageChanged(true); // Set flag to true to track image change
      };
    }
  };
  const handleBannerImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        setBannerImageSrc(reader.result); // Set banner image source for cropping
        setIsBannerImageChanged(true)
      };
    }
  };

  const handleCroppedImageSubmit = (croppedImageBase64) => {
    setFormData((prevData) => ({
      ...prevData,
      banner_image: croppedImageBase64 // Store cropped image in formData
    }));
  };
  const handleBannerCroppedImageSubmit = (croppedImageBase64) => {
    setFormData((prevData) => ({
      ...prevData,
      main_banner_image: croppedImageBase64, // Store cropped banner image in formData
    }));
  };

  const loadvendor = async () => {
    const access_token = localStorage.getItem('access_token');
    const config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    };
    HTTP.get("vendors/me", config, config)
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data.business_name)
          setFormData((prevData) => ({
            ...prevData,
            owner_first_name: response.data.first_name || "",
            owner_last_name: response.data.last_name || "",
            business_name: response.data.business_name || "",
            email: response.data.email || "",
            phone_number: response.data.contact_no || "",

            business_description: response.data.business_description || "",
            business_category_id: response.data.business_category_id || "",
            business_site_url: response.data.business_site_url || "",

            x_url: response.data.x_url || "",
            facebook_url: response.data.facebook_url || "",
            youtube_url: response.data.youtube_url || "",
            banner_image: response.data.banner_image || "",

            short_description: response.data.short_description || "",
            main_banner_image: response.data.main_banner_image || "",

          }));
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
          localStorage.clear();
          navigate('/'); // Redirect to login page
        }

      });
  }
  const loadCategories = async () => {
    try {
      let fields = {
        filters: {
          // coupon_type: filterType
        },
        pagination: pagination,
        sorting: { field: 'name', type: 'asc' },
      };
      await HTTP.post("/business_cate/list/all", fields)
        .then(async (response) => {
          if (response.status === 200) {
            setCategoriesList(response.data.contents)
          }
        })
        .catch((error) => {
          // setError(error);
          // setRerenderFlag(true);
          // loadAaMasterData();
          // resetValidationErrors();
        });

      // setIsLoading(false);
    } catch (error) {
      // setError(error);
      // setRerenderFlag(true);
      // setIsLoading(false);
    }
  }

  // const handleChange = (e) => {
  //   const { name, value, files } = e.target;

  //   if (name === "banner_image") {
  //     const file = files[0]; // Get the selected file
  //     if (file) {
  //       // Generate a preview URL using FileReader
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         setBannerPreview(reader.result); // Set preview URL
  //         setFormData({ ...formData, banner_image: file }); // Set the file in formData
  //       };
  //       reader.readAsDataURL(file); // Convert file to base64 string
  //     }
  //   } else {
  //     setFormData({ ...formData, [name]: value });
  //   }
  // };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "banner_image" || name === "main_banner_image") {
      const file = files[0]; // Get the selected file
      if (file) {
        // Generate a preview URL using FileReader
        const reader = new FileReader();
        reader.onloadend = () => {
          if (name === "banner_image") {
            setBannerPreview(reader.result); // Set preview URL for banner_image
          } else if (name === "main_banner_image") {
            setMainBannerPreview(reader.result); // Set preview URL for main_banner_image
          }
          setFormData({ ...formData, [name]: file }); // Set the file in formData
        };
        reader.readAsDataURL(file); // Convert file to base64 string
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };



  // const handleRadioChange = (e) => {
  //   setFormData({ ...formData, same_address: e.target.value });
  // };


  const resetValidationErrors = () => {
    setFirstNameError('');
    setLastNameError('');
    setBusinessNameError('');
    setBusinessDescriptionError('');
    setPhoneNumberError('');
    setEmailError('');
    setCategoryIdError('');
    setUrlError('');
    setFacebookError('');
    setXError('');
    setYoutubeError('');
    setShortDescriptionError('');
  };
  const validateField = () => {
    resetValidationErrors();

    let checked = true;
    if (formData.owner_first_name === '') {
      setFirstNameError('Please enter first name');
      if (checked) {
        checked = false;
      }
    } else if ((formData.owner_first_name).length < 5) {
      setFirstNameError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if ((formData.owner_first_name).length > 100) {
      setFirstNameError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    if (formData.owner_last_name === '') {
      setLastNameError('Please enter last name');
      if (checked) {
        checked = false;
      }
    } else if (formData.owner_last_name.length < 5) {
      setLastNameError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if (formData.owner_last_name.length > 100) {
      setLastNameError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }


    if (formData.owner_last_name === '') {
      setLastNameError('Please enter last name');
      if (checked) {
        checked = false;
      }
    } else if ((formData.owner_last_name).length < 5) {
      setLastNameError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if ((formData.owner_last_name).length > 100) {
      setLastNameError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }
    if (formData.business_name === '') {
      setBusinessNameError('Please enter business name');
      if (checked) {
        checked = false;
      }
    } else if ((formData.business_name).length < 5) {
      setBusinessNameError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if ((formData.business_name).length > 100) {
      setBusinessNameError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    if (formData.business_category_id === '') {
      setCategoryIdError('Select business category');
      if (checked) {
        checked = false;
      }
    }

    if (formData.business_description === '') {
      setBusinessDescriptionError('Please enter business description');
      if (checked) {
        checked = false;
      }
    } else if ((formData.business_description).length < 5) {
      setBusinessDescriptionError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    }
    // else if ((formData.business_description).length > 100) {
    //   setBusinessDescriptionError("Max character limit is 100");
    //   if (checked) {
    //     checked = false;
    //   }
    // }

    if (formData.phone_number === '') {
      setPhoneNumberError('Please enter phone number');
      if (checked) {
        checked = false;
      }
    } else if ((formData.phone_number).length > 100) {
      setPhoneNumberError("Max character limit is 10");
      if (checked) {
        checked = false;
      }
    }

    if (formData.email === '') {
      setEmailError('Please enter email address');
      if (checked) {
        checked = false;
      }
    }
    else if (!isValidEmail(formData.email)) {
      setEmailError('Invalid email.');
      if (checked) {
        checked = false;
      }
    } else if ((formData.email).length > 100) {
      setEmailError("Max character limit is 100");
      if (checked) {
        checked = false;
      }
    }

    let errorMessage = '';
    const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9.-]+)(\.[a-zA-Z]{2,})(:\d+)?(\/[^\s]*)?$/;

    if (formData.business_site_url && !urlRegex.test(formData.business_site_url)) {
      errorMessage = `Invalid url`;
      setUrlError(errorMessage);
      if (checked) {
        checked = false;
      }
    }

    if (formData.facebook_url && !urlRegex.test(formData.facebook_url)) {
      errorMessage = `Invalid facebook url`;
      setFacebookError(errorMessage);
      if (checked) {
        checked = false;
      }
    }

    if (formData.x_url && !urlRegex.test(formData.x_url)) {
      errorMessage = `Invalid x url`;
      setXError(errorMessage);
      if (checked) {
        checked = false;
      }
    }

    if (formData.youtube_url && !urlRegex.test(formData.youtube_url)) {
      errorMessage = `Invalid youtube url`;
      setYoutubeError(errorMessage);
      if (checked) {
        checked = false;
      }
    }

    if (formData.short_description === '') {
      setShortDescriptionError('Please enter business description');
      if (checked) {
        checked = false;
      }
    } else if ((formData.short_description).length < 5) {
      setShortDescriptionError("Please enter minimum 5 characters");
      if (checked) {
        checked = false;
      }
    } else if ((formData.short_description).length > 200) {
      setShortDescriptionError("Max character limit is 200");
      if (checked) {
        checked = false;
      }
    }



    return checked;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateField()) {
      try {
        const access_token = localStorage.getItem("access_token");
        const formDataObj = new FormData();

        Object.keys(formData).forEach((key) => {
          if (key !== "banner_image" && key !== "main_banner_image" && formData[key]) {
            formDataObj.append(key, formData[key]);
          }
        });

        // Only append banner_image if it was changed
        if (isImageChanged && formData.banner_image) {
          // Append cropped image as a base64 string
          const blob = await fetch(formData.banner_image).then(res => res.blob()); // Convert base64 to blob
          formDataObj.append("banner_image", blob, "cropped-logo-image.png");
        }

        if (isBannerImageChanged && fileInputRef2.current && fileInputRef2.current.files.length > 0) {
          const blob = await fetch(formData.main_banner_image).then(res => res.blob()); // Convert base64 to blob
          formDataObj.append("main_banner_image", blob ,"cropped-banner-image.png");
        }

        const config = {
          headers: {
            "Content-Type": "multipart/form-data", // Required for file uploads
            token: access_token,
          },
        };

        const response = await HTTP.post("/vendors/profile/update", formDataObj, config);

        if (response.status === 200) {
          Swal.fire({
            title: "Profile updated successfully!",
            icon: "success",
          });
        }
      } catch (error) {
        const errorMessage = error.response?.data?.detail || "An unexpected error occurred";
        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error",
        });
      }
    }
  };


  const handleDeleteLoginImage = async (e) => {
    e.preventDefault();
    try {
      const access_token = localStorage.getItem("access_token");
      const config = {
        headers: {
          "Content-Type": "multipart/form-data", // Required for file uploads
          token: access_token,
        },
      };

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        const response = await HTTP.delete('vendors/delete-banner', config);
        console.log("response", response) // Use HTTP instance for the DELETE request
        if (response.data.status === '200') {
          console.log("response", response)
          // Clear the banner image in state
          setFormData((prev) => ({
            ...prev,
            banner_image: null,
          }));
          loadvendor();
        }
      }


    } catch (error) {
      console.error('Error deleting banner image:', error);
      // Handle error (e.g., show an alert or a message to the user)
    }
  };

  const handleDeleteLogoImage = async (e) => {
    e.preventDefault();
    try {
      const access_token = localStorage.getItem("access_token");
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          token: access_token,
        },
      };

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        const response = await HTTP.delete('vendors/delete-logo', config);
        if (response.data.status === '200') {
          loadvendor();
        }
      }


    } catch (error) {
      console.error('Error deleting banner image:', error);
      // Handle error (e.g., show an alert or a message to the user)
    }
  };

  const handleDeleteBannerImage = async (e) => {
    e.preventDefault();
    try {
      const access_token = localStorage.getItem("access_token");
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          token: access_token,
        },
      };

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        const response = await HTTP.delete('vendors/delete-banner', config);
        if (response.data.status === '200') {
          // setFormData((prev) => ({
          //   ...prev,
          //   main_banner_image: null,
          // }));
          loadvendor();
        }
      }


    } catch (error) {
      console.error('Error deleting banner image:', error);
      // Handle error (e.g., show an alert or a message to the user)
    }
  };

  return (
    <>
      <form className="space-y-4 mt-8" onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="bg-white rounded-lg p-6 border-gray-200 border">
          <h3 className="font-medium text-lg mb-4">Personal Information</h3>
          <div className="grid grid-cols-2 gap-4">
            {/* Business Name */}
            <div className="md:space-y-2">
              <label htmlFor="business_name" className="text-sm font-medium">
                Business Name
              </label>
              <input
                type="text"
                id="business_name"
                name="business_name"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.business_name}
                onChange={handleChange}
              />
              {businessNameError && <span className="text-sm text-red-500">{businessNameError}</span>}
            </div>

            {/* Business Category */}
            <div className="md:space-y-2">
              <label htmlFor="business_category" className="text-sm font-medium">
                Business Category
              </label>
              <select
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                name="business_category_id"
                value={formData.business_category_id}
                onChange={handleChange}
              >
                <option value="">Select Category Type</option>
                {Array.isArray(categoriesList) && categoriesList.length > 0
                  ? categoriesList.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))
                  : null}
              </select>
              {categoryIdError && <span className="text-sm text-red-500">{categoryIdError}</span>}
            </div>

            {/* Email */}
            <div className="md:space-y-2">
              <label htmlFor="email" className="text-sm font-medium">
                Email
              </label>
              <input
                disabled="disable"
                type="email"
                id="email"
                name="email"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.email}
                onChange={handleChange}
              />
              {emailError && <span className="text-sm text-red-500">{emailError}</span>}
            </div>

            {/* Mobile Number */}
            <div className="md:space-y-2">
              <label htmlFor="phone_number" className="text-sm font-medium">
                Phone
              </label>
              <input
                type="tel"
                id="phone_number"
                name="phone_number"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.phone_number}
                onChange={handleChange}
              />
              {phoneNumberError && <span className="text-sm text-red-500">{phoneNumberError}</span>}
            </div>

            {/* Logo Image */}
            <div className="md:space-y-2">
              <label htmlFor="file" className="text-sm font-medium">
                Logo Image
              </label>
              <input
                type="file"
                id="banner_image"
                name="banner_image"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                onChange={handleImageChange}
                ref={fileInputRef}
              />
              {formData.banner_image.length == 0 && <p className="text-sm text-red-500">Image Only</p>}


              {/* Pass the image source and handle the cropped image submission */}
              <ImageCropper aspect={4/3} imageSrc={imageSrc} onClick={handleCroppedImageSubmit} />

              {/* Preview the cropped image after submission */}
              {formData.banner_image && (
                <>
                  <div className="w-1/4">
                    <h3 className="font-semibold my-3"> Uploaded Image</h3>
                  </div>
                  <div className="relative mt-2 flexbox ">
                    <div className="w-2/3">

                      <img src={formData.banner_image} className="upload-image" alt="Cropped Banner" />
                      {!formData.banner_image.includes('/default_vendor_banner.png') && (
                        <button
                          className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                          onClick={handleDeleteLogoImage}
                        >
                          <X />
                        </button>
                      )}
                    </div>
                    <div className="w-1/4 items-center justify-center">
                      <div className=" items-center justify-center">

                        <span className="mr-3  profile-image-preview flexbox flex-col justify-center">
                          <img src={formData.banner_image} alt="Cropped Banner" />
                          <p className="mt-1.5 text-xs font-semibold"> Profile image</p>
                        </span>
                        <span className="mr-3 mt-3 coupon-image-preview flexbox flex-col justify-center">
                          <img src={formData.banner_image} alt="coupon image" />
                          <p className="mt-1.5 text-xs font-semibold"> Coupon Image</p>
                        </span>
                      </div>

                    </div>

                  </div>
                </>
              )}
            </div>

            {/* Banner Image */}
            <div className="md:space-y-2">
              <label htmlFor="file" className="text-sm font-medium">
                Banner Image
              </label>
              <input
                type="file"
                id="main_banner_image"
                name="main_banner_image"
                onChange={handleBannerImageChange}
                ref={fileInputRef2}
              />
              {formData.main_banner_image.length < 0 && <p className="text-sm text-red-500">Image Only</p>}

              <ImageCropper aspect={16/9} imageSrc={bannerImageSrc} onClick={handleBannerCroppedImageSubmit} label="Banner" />
              {formData.main_banner_image && (
                <div className="relative mt-2">
                  <h3 className="font-semibold my-3"> Uploaded Banner Image</h3>
                  <img
                    src={formData.main_banner_image}
                    alt="Banner Preview"
                    className="upload-image"
                  />
                  {/* Only show delete button if image src does not contain '/None' */}
                  {!formData.main_banner_image.includes('/default_vendor_banner.png') && (
                    <button
                      className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1"
                      onClick={handleDeleteBannerImage}
                    >
                      <X />
                    </button>
                  )}
                </div>
              )}
            </div>

            <div className="md:space-y-2">
              <label htmlFor="short_description" className="text-sm font-medium">
                Short Description
              </label>
              <textarea
                type=""
                row="4"
                id="short_description"
                name="short_description"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.short_description}
                onChange={handleChange}
              />
              {shortDescriptionError && <span className="text-sm text-red-500">{shortDescriptionError}</span>}
            </div>

            {/* Business Description */}
            <div className="md:space-y-2">
              <label htmlFor="business_description" className="text-sm font-medium">
                Business Description
              </label>
              <textarea
                type=""
                row="4"
                id="business_description"
                name="business_description"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.business_description}
                onChange={handleChange}
              />
              {businessDescriptionError && <span className="text-sm text-red-500">{businessDescriptionError}</span>}
            </div>

            {/* Owner First Name */}
            <div className="md:space-y-2">
              <label htmlFor="owner_first_name" className="text-sm font-medium">
                Owner First Name
              </label>
              <input
                type="text"
                id="owner_first_name"
                name="owner_first_name"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.owner_first_name}
                onChange={handleChange}
              />
              {firstNameError && <span className="text-sm text-red-500">{firstNameError}</span>}
            </div>

            {/* Owner Last Name */}
            <div className="md:space-y-2">
              <label htmlFor="owner_last_name" className="text-sm font-medium">
                Owner Last Name
              </label>
              <input
                type="text"
                id="owner_last_name"
                name="owner_last_name"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.owner_last_name}
                onChange={handleChange}
              />
              {lastNameError && <span className="text-sm text-red-500">{lastNameError}</span>}
            </div>

            {/* Business Site Url */}
            <div className="md:space-y-2">
              <label htmlFor="business_site_url" className="text-sm font-medium">
                Website Url
              </label>
              <input
                type="text"
                id="business_site_url"
                name="business_site_url"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.business_site_url}
                onChange={handleChange}
              />
              {urlError && <span className="text-sm text-red-500">{urlError}</span>}
            </div>

            {/* Facebook Url */}
            <div className="md:space-y-2">
              <label htmlFor="facebook_url" className="text-sm font-medium">
                Facebook Url
              </label>
              <input
                type="text"
                id="facebook_url"
                name="facebook_url"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.facebook_url}
                onChange={handleChange}
              />
              {facebookError && <span className="text-sm text-red-500">{facebookError}</span>}
            </div>

            {/* X Url */}
            <div className="md:space-y-2">
              <label htmlFor="x_url" className="text-sm font-medium">
                X (Twitter) Url
              </label>
              <input
                type="text"
                id="x_url"
                name="x_url"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.x_url}
                onChange={handleChange}
              />
              {xError && <span className="text-sm text-red-500">{xError}</span>}
            </div>

            {/* YouTube Url */}
            <div className="md:space-y-2">
              <label htmlFor="youtube_url" className="text-sm font-medium">
                YouTube Url
              </label>
              <input
                type="text"
                id="youtube_url"
                name="youtube_url"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                value={formData.youtube_url}
                onChange={handleChange}
              />
              {youtubeError && <span className="text-sm text-red-500">{youtubeError}</span>}
            </div>

          </div>
        </div>
        <button
          type="submit"
          className="theme-button text-white px-4 py-2 rounded-md shadow-sm"
        >
          Submit
        </button>
      </form>
    </>
  )
}

export default VendorProfile